import { render, staticRenderFns } from "./DeadlineEntryListItem.vue?vue&type=template&id=3bc8c03e"
import script from "./DeadlineEntryListItem.vue?vue&type=script&lang=js"
export * from "./DeadlineEntryListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports